import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}
